import { render } from "./SettingsTrainConfigurations.vue?vue&type=template&id=67ca44ab"
import script from "./SettingsTrainConfigurations.vue?vue&type=script&lang=js"
export * from "./SettingsTrainConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__